// extracted by mini-css-extract-plugin
module.exports = {"fullContB":"Shorts_fullContB__APb-_"};